import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";

export default function PoliticaCookies() {
  return (
    <div className="min-h-screen pt-20" data-testid="politica-cookies-page">
      <Helmet>
        <title>Política de Cookies | SOSTRE BALEAR</title>
        <meta name="description" content="Información sobre el uso de cookies en el sitio web SOSTRE BALEAR." />
        <link rel="canonical" href="https://www.sostrebalear.com/politica-cookies" />
        <meta name="robots" content="noindex, follow" />
      </Helmet>
      <section className="py-16 md:py-24 bg-gradient-to-b from-slate-50 to-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <span className="text-sm font-medium tracking-wide uppercase text-[#22c55e]">
            Legal
          </span>
          <h1 className="text-3xl md:text-4xl font-bold text-slate-900 mt-3 tracking-tight">
            Política de Cookies
          </h1>
          <p className="text-slate-500 mt-4">
            Última actualización: Enero 2026
          </p>
        </div>
      </section>

      <section className="py-12 md:py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 prose prose-slate max-w-none">
          
          <h2 className="text-xl font-semibold text-slate-900 mt-8 mb-4">
            1. ¿Qué son las Cookies?
          </h2>
          <p className="text-slate-600 mb-6">
            Las cookies son pequeños archivos de texto que los sitios web almacenan en su dispositivo (ordenador, tablet o móvil) cuando los visita. Se utilizan ampliamente para hacer que los sitios web funcionen de manera más eficiente, así como para proporcionar información a los propietarios del sitio.
          </p>

          <h2 className="text-xl font-semibold text-slate-900 mt-8 mb-4">
            2. Responsable del Uso de Cookies
          </h2>
          <ul className="list-disc pl-6 text-slate-600 mb-6 space-y-2">
            <li><strong>Responsable:</strong> PASTORIA PROJECT SL</li>
            <li><strong>CIF:</strong> B57664179</li>
            <li><strong>Domicilio:</strong> Camí Son Rapinya, nº8 1ºA, 07013 Palma (Illes Balears)</li>
            <li><strong>Correo electrónico:</strong> info@pastoria.es</li>
            <li><strong>Sitio web:</strong> www.pastoria.es</li>
          </ul>

          <h2 className="text-xl font-semibold text-slate-900 mt-8 mb-4">
            3. Tipos de Cookies que Utilizamos
          </h2>
          
          <h3 className="text-lg font-medium text-slate-800 mt-6 mb-3">
            3.1. Cookies Técnicas (Necesarias)
          </h3>
          <p className="text-slate-600 mb-4">
            Son aquellas que permiten al usuario la navegación a través de la página web y la utilización de las diferentes opciones o servicios que en ella existen. No requieren consentimiento.
          </p>
          <div className="overflow-x-auto mb-6">
            <table className="min-w-full border border-slate-200 text-sm">
              <thead className="bg-slate-50">
                <tr>
                  <th className="px-4 py-2 text-left border-b">Cookie</th>
                  <th className="px-4 py-2 text-left border-b">Finalidad</th>
                  <th className="px-4 py-2 text-left border-b">Duración</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="px-4 py-2 border-b">cookies_consent</td>
                  <td className="px-4 py-2 border-b">Almacena la preferencia de cookies del usuario</td>
                  <td className="px-4 py-2 border-b">1 año</td>
                </tr>
              </tbody>
            </table>
          </div>

          <h3 className="text-lg font-medium text-slate-800 mt-6 mb-3">
            3.2. Cookies Analíticas
          </h3>
          <p className="text-slate-600 mb-4">
            Permiten cuantificar el número de usuarios y realizar la medición y análisis estadístico de la utilización del sitio web. Requieren consentimiento del usuario.
          </p>
          <div className="overflow-x-auto mb-6">
            <table className="min-w-full border border-slate-200 text-sm">
              <thead className="bg-slate-50">
                <tr>
                  <th className="px-4 py-2 text-left border-b">Cookie</th>
                  <th className="px-4 py-2 text-left border-b">Proveedor</th>
                  <th className="px-4 py-2 text-left border-b">Finalidad</th>
                  <th className="px-4 py-2 text-left border-b">Duración</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="px-4 py-2 border-b">_ga</td>
                  <td className="px-4 py-2 border-b">Google Analytics</td>
                  <td className="px-4 py-2 border-b">Distinguir usuarios únicos</td>
                  <td className="px-4 py-2 border-b">2 años</td>
                </tr>
                <tr>
                  <td className="px-4 py-2 border-b">_ga_*</td>
                  <td className="px-4 py-2 border-b">Google Analytics</td>
                  <td className="px-4 py-2 border-b">Mantener el estado de la sesión</td>
                  <td className="px-4 py-2 border-b">2 años</td>
                </tr>
              </tbody>
            </table>
          </div>

          <h2 className="text-xl font-semibold text-slate-900 mt-8 mb-4">
            4. Base Legal para el Uso de Cookies
          </h2>
          <p className="text-slate-600 mb-4">
            El uso de cookies en este sitio web se basa en:
          </p>
          <ul className="list-disc pl-6 text-slate-600 mb-6 space-y-2">
            <li><strong>Cookies técnicas:</strong> Interés legítimo y necesidad técnica (no requieren consentimiento).</li>
            <li><strong>Cookies analíticas:</strong> Consentimiento del usuario (Art. 6.1.a RGPD).</li>
          </ul>

          <h2 className="text-xl font-semibold text-slate-900 mt-8 mb-4">
            5. Gestión de Cookies
          </h2>
          <p className="text-slate-600 mb-4">
            Al acceder a nuestro sitio web por primera vez, se le mostrará un banner informativo sobre el uso de cookies, donde podrá:
          </p>
          <ul className="list-disc pl-6 text-slate-600 mb-6 space-y-2">
            <li><strong>Aceptar todas:</strong> Consiente el uso de todas las cookies.</li>
            <li><strong>Rechazar:</strong> Solo se utilizarán cookies técnicas necesarias.</li>
            <li><strong>Configurar:</strong> Elegir qué tipos de cookies acepta.</li>
          </ul>

          <h2 className="text-xl font-semibold text-slate-900 mt-8 mb-4">
            6. Cómo Desactivar las Cookies en su Navegador
          </h2>
          <p className="text-slate-600 mb-4">
            Puede configurar su navegador para bloquear o alertar sobre estas cookies. A continuación, le proporcionamos enlaces a las instrucciones de los navegadores más comunes:
          </p>
          <ul className="list-disc pl-6 text-slate-600 mb-6 space-y-2">
            <li>
              <a href="https://support.google.com/chrome/answer/95647" target="_blank" rel="noopener noreferrer" className="text-[#22c55e] hover:underline">
                Google Chrome
              </a>
            </li>
            <li>
              <a href="https://support.mozilla.org/es/kb/habilitar-y-deshabilitar-cookies-sitios-web-rastrear-preferencias" target="_blank" rel="noopener noreferrer" className="text-[#22c55e] hover:underline">
                Mozilla Firefox
              </a>
            </li>
            <li>
              <a href="https://support.apple.com/es-es/guide/safari/sfri11471/mac" target="_blank" rel="noopener noreferrer" className="text-[#22c55e] hover:underline">
                Safari
              </a>
            </li>
            <li>
              <a href="https://support.microsoft.com/es-es/windows/eliminar-y-administrar-cookies-168dab11-0753-043d-7c16-ede5947fc64d" target="_blank" rel="noopener noreferrer" className="text-[#22c55e] hover:underline">
                Microsoft Edge
              </a>
            </li>
          </ul>
          <p className="text-slate-600 mb-6">
            Tenga en cuenta que si desactiva todas las cookies, es posible que algunas funcionalidades del sitio web no funcionen correctamente.
          </p>

          <h2 className="text-xl font-semibold text-slate-900 mt-8 mb-4">
            7. Transferencias Internacionales
          </h2>
          <p className="text-slate-600 mb-6">
            Algunos de los terceros que utilizamos para el análisis web (como Google) pueden transferir datos a servidores ubicados fuera del Espacio Económico Europeo. Estos proveedores cumplen con las garantías adecuadas según el RGPD, incluyendo las Cláusulas Contractuales Tipo aprobadas por la Comisión Europea.
          </p>

          <h2 className="text-xl font-semibold text-slate-900 mt-8 mb-4">
            8. Actualización de la Política de Cookies
          </h2>
          <p className="text-slate-600 mb-6">
            PASTORIA PROJECT SL puede modificar esta Política de Cookies en función de exigencias legislativas, reglamentarias, o con la finalidad de adaptar dicha política a las instrucciones dictadas por la Agencia Española de Protección de Datos. Se recomienda al usuario que consulte esta página periódicamente.
          </p>

          <h2 className="text-xl font-semibold text-slate-900 mt-8 mb-4">
            9. Más Información
          </h2>
          <p className="text-slate-600 mb-6">
            Para más información sobre cómo tratamos sus datos personales, consulte nuestra{" "}
            <Link to="/politica-privacidad" className="text-[#22c55e] hover:underline">
              Política de Privacidad
            </Link>.
          </p>
          <p className="text-slate-600 mb-6">
            Si tiene cualquier duda sobre esta Política de Cookies, puede contactar con nosotros en:{" "}
            <a href="mailto:info@pastoria.es" className="text-[#22c55e] hover:underline">
              info@pastoria.es
            </a>
          </p>

          <h2 className="text-xl font-semibold text-slate-900 mt-8 mb-4">
            10. Legislación Aplicable
          </h2>
          <ul className="list-disc pl-6 text-slate-600 mb-6 space-y-2">
            <li>Reglamento (UE) 2016/679 (RGPD)</li>
            <li>Ley Orgánica 3/2018, de 5 de diciembre (LOPDGDD)</li>
            <li>Ley 34/2002, de 11 de julio (LSSI-CE)</li>
            <li>Directiva 2002/58/CE (Directiva ePrivacy)</li>
          </ul>

        </div>
      </section>
    </div>
  );
}
